(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["dd-atc-row"] && !Shopify.designMode) return;
  try {
    (function () {
    function update(section) {
      var note = section.querySelector('[data-dd-mm-subnote]');
      if (!note) return;
      var cb = section.querySelector('[data-dd-mm-mode-checkbox]');
      var subscribed = cb ? cb.checked : true;
      var current = section.querySelector('[data-dd-mm-offer].is-current');
      var freq = current ? (current.getAttribute('data-subscription-frequency') || '') : '';
      if (!subscribed || !freq) {
        note.style.display = 'none';
        return;
      }
      var cadence = freq.trim().toLowerCase();
      var digits = freq.match(/\d+/);
      var tpl = note.getAttribute('data-template') || '';
      note.textContent = tpl
        .replace(/\{cadence\}/gi, cadence)
        .replace(/\{days\}/gi, digits ? digits[0] : '');
      note.style.display = '';
    }

    function initSection(section) {
      if (section.dataset.ddSubnoteInited === 'true') return;
      section.dataset.ddSubnoteInited = 'true';

      var schedule = function () {
        requestAnimationFrame(function () { update(section); });
      };

      section.addEventListener('dd-mm:mode', schedule);
      section.addEventListener('click', schedule);

      if (typeof MutationObserver !== 'undefined') {
        var obs = new MutationObserver(schedule);
        section.querySelectorAll('[data-dd-mm-offer]').forEach(function (o) {
          obs.observe(o, { attributes: true, attributeFilter: ['class'] });
        });
      }

      update(section);
      [0, 50, 250, 800, 1500].forEach(function (ms) {
        setTimeout(function () { update(section); }, ms);
      });
    }

    function boot() {
      document.querySelectorAll('.dd-mm-section').forEach(initSection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
    document.addEventListener('shopify:section:load', function (ev) {
      var t = ev.target;
      if (t && typeof t.querySelectorAll === 'function') {
        t.querySelectorAll('.dd-mm-section').forEach(function (el) {
          delete el.dataset.ddSubnoteInited;
        });
      }
      boot();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["dd-bundle-offer-item"] && !Shopify.designMode) return;
  try {
    (function () {
    function moneyFmt(currency, cents, noDecimals) {
      var value = Number(cents || 0) / 100;
      try {
        return new Intl.NumberFormat(undefined, {
          style: 'currency',
          currency: currency || 'USD',
          currencyDisplay: 'narrowSymbol',
          minimumFractionDigits: noDecimals ? 0 : 2,
          maximumFractionDigits: noDecimals ? 0 : 2
        }).format(value);
      } catch (e) {
        return '$' + value.toLocaleString(undefined, {
          minimumFractionDigits: noDecimals ? 0 : 2,
          maximumFractionDigits: noDecimals ? 0 : 2
        });
      }
    }

    function setBadge(badgeEl, saveEl, currency, saveCents, bg) {
      if (!saveEl) return;
      if (saveCents > 0) {
        saveEl.setAttribute('data-dd-mm-money-cents', saveCents);
        saveEl.setAttribute('data-dd-mm-money-no-decimals', 'true');
        saveEl.textContent = moneyFmt(currency, saveCents, true);
        if (badgeEl) {
          badgeEl.style.visibility = 'visible';
          badgeEl.style.background = bg || '';
        }
      } else if (badgeEl) {
        badgeEl.style.visibility = 'hidden';
      }
    }

    function applyStepMode(step, mode, currency) {
      var nowEl = step.querySelector('[data-dd-mm-offer-now]');
      var wasEl = step.querySelector('[data-dd-mm-offer-was]');
      var badgeEl = step.querySelector('[data-dd-mm-offer-badge]');
      var saveEl = step.querySelector('[data-dd-mm-offer-save]');
      var subCents = Number(step.getAttribute('data-bundle-price') || 0);
      var otpCents = Number(step.getAttribute('data-one-time-bundle-price') || 0);
      var retailCents = Number(step.getAttribute('data-retail-compare') || 0);
      var tierColor = badgeEl ? (badgeEl.getAttribute('data-dd-mm-badge-color') || '') : '';

      if (mode === 'one_time') {
        if (nowEl && otpCents > 0) {
          nowEl.setAttribute('data-dd-mm-money-cents', otpCents);
          nowEl.textContent = moneyFmt(currency, otpCents);
          nowEl.style.color = '#111111';
        }
        if (wasEl) wasEl.style.display = 'none';
        setBadge(badgeEl, saveEl, currency, retailCents - otpCents, tierColor);
      } else {
        if (nowEl && subCents > 0) {
          nowEl.setAttribute('data-dd-mm-money-cents', subCents);
          nowEl.textContent = moneyFmt(currency, subCents);
          nowEl.style.color = '';
        }
        if (wasEl && retailCents > 0) {
          wasEl.style.display = '';
          wasEl.setAttribute('data-dd-mm-money-cents', retailCents);
          wasEl.textContent = moneyFmt(currency, retailCents);
        }
        setBadge(badgeEl, saveEl, currency, retailCents - subCents, tierColor);
      }
    }

    function updateAll(section, mode) {
      var currency = section.getAttribute('data-dd-mm-currency') || 'USD';
      section.querySelectorAll('[data-dd-mm-offer-title]').forEach(function (title) {
        title.textContent = mode === 'one_time'
          ? (title.dataset.titleOneTime || title.dataset.titleSubscription)
          : title.dataset.titleSubscription;
      });
      section.querySelectorAll('[data-dd-mm-offer]').forEach(function (step) {
        applyStepMode(step, mode, currency);
      });
    }

    function initOfferTitles(section) {
      section.addEventListener('dd-mm:mode', function (e) {
        updateAll(section, e.detail.mode);
      });
      section.querySelectorAll('[data-dd-mm-mode-btn]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          updateAll(section, btn.dataset.mode);
        });
      });
      updateAll(section, 'subscription');
    }

    function boot() {
      document.querySelectorAll('.dd-mm-section').forEach(initOfferTitles);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["dd-content-header"] && !Shopify.designMode) return;
  try {
    (function () {
    // Central reorder: desktop keeps the 2-column layout; mobile (<=980) runs in a
    // single column with photos tucked between the review stats and the description,
    // and the review box dropped to the very bottom (after the FAQ).
    function reorder(section) {
      var left = section.querySelector('.dd-mm-left');
      var right = section.querySelector('.dd-mm-right');
      var header = section.querySelector('.dd-mm-header');
      var gallery = section.querySelector('.dd-mm-gallery');
      var ratingWrap = header ? header.querySelector('.dd-mm-rating-row-wrap') : null;
      var featured = section.querySelector('.dd-pv2-featured');
      var faq = section.querySelector('.dd-mm-faq-group');
      if (!left || !right) return;

      if (window.innerWidth <= 980) {
        if (gallery && ratingWrap && ratingWrap.nextElementSibling !== gallery) {
          ratingWrap.insertAdjacentElement('afterend', gallery);
        }
        if (featured && right.lastElementChild !== featured) {
          right.appendChild(featured);
        }
        if (faq && featured && featured.previousElementSibling !== faq) {
          right.insertBefore(faq, featured);
        } else if (faq && !featured && right.lastElementChild !== faq) {
          right.appendChild(faq);
        }
      } else {
        if (gallery && left.firstElementChild !== gallery) {
          left.insertBefore(gallery, left.firstElementChild);
        }
        if (featured) {
          if (gallery && gallery.parentElement === left) {
            if (gallery.nextElementSibling !== featured) gallery.insertAdjacentElement('afterend', featured);
          } else if (featured.parentElement !== left) {
            left.appendChild(featured);
          }
        }
        if (faq && featured && featured.parentElement === left && featured.nextElementSibling !== faq) {
          featured.insertAdjacentElement('afterend', faq);
        }
      }
    }

    function run() {
      document.querySelectorAll('.dd-mm-section').forEach(reorder);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run);
    } else {
      run();
    }
    var t;
    window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(run, 120); });
    document.addEventListener('shopify:section:load', run);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["dd-free-gifts"] && !Shopify.designMode) return;
  try {
    (function () {
    function applyGiftsMode(section, mode) {
      section.querySelectorAll('[data-dd-mm-gifts-heading]').forEach(function (heading) {
        heading.textContent = mode === 'one_time'
          ? (heading.dataset.headingOneTime || heading.dataset.headingSubscription)
          : heading.dataset.headingSubscription;
      });
    }

    function initGiftsMode(section) {
      section.addEventListener('dd-mm:mode', function (e) {
        applyGiftsMode(section, e.detail.mode);
      });
      // Backward-compat: legacy mode buttons
      section.querySelectorAll('[data-dd-mm-mode-btn]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          applyGiftsMode(section, btn.dataset.mode);
        });
      });
    }

    function boot() {
      document.querySelectorAll('.dd-mm-section').forEach(initGiftsMode);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["dd-mix-match-list"] && !Shopify.designMode) return;
  try {
    (function () {
    function initScroll(section) {
      section.querySelectorAll('[data-dd-mm-scroll]').forEach(function (box) {
        if (box.dataset.ddScrollInited === 'true') return;
        box.dataset.ddScrollInited = 'true';
        var wrap = box.closest('[data-dd-mm-mixmatch-wrap]') || box.parentElement;
        var more = wrap ? wrap.querySelector('[data-dd-mm-scroll-more]') : null;
        function check() {
          if (!more) return;
          var atBottom = box.scrollTop + box.clientHeight >= box.scrollHeight - 4;
          var noScroll = box.scrollHeight <= box.clientHeight + 4;
          more.classList.toggle('is-hidden', atBottom || noScroll);
        }
        box.addEventListener('scroll', check);
        check();
        [150, 500, 1200].forEach(function (ms) { setTimeout(check, ms); });
        window.addEventListener('resize', check);
      });
    }
    function boot() {
      document.querySelectorAll('.dd-mm-section').forEach(initScroll);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
    document.addEventListener('shopify:section:load', boot);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["dd-purchase-options"] && !Shopify.designMode) return;
  try {
    (function () {
    var LOCK_SVG = '<svg width="16" height="18" viewBox="0 0 24 24" fill="none" stroke="#1c365e" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg"><rect x="4" y="11" width="16" height="10" rx="2"/><path d="M8 11V7a4 4 0 0 1 8 0v4"/></svg>';

    function getOffers(section) {
      return Array.prototype.slice.call(section.querySelectorAll('[data-dd-mm-offer]'));
    }

    function currentTierIndex(offers) {
      for (var i = 0; i < offers.length; i++) {
        if (offers[i].classList.contains('is-current')) return i;
      }
      return -1;
    }

    function formatMoney(section, cents) {
      var v = (Number(cents) || 0) / 100;
      var whole = v % 1 === 0;
      try {
        return new Intl.NumberFormat(undefined, {
          style: 'currency',
          currency: section.dataset.ddMmCurrency || 'USD',
          currencyDisplay: 'narrowSymbol',
          minimumFractionDigits: whole ? 0 : 2,
          maximumFractionDigits: 2
        }).format(v);
      } catch (e) {
        return '$' + (whole ? v.toFixed(0) : v.toFixed(2));
      }
    }

    function parseList(str) {
      if (!str) return [];
      return str.split('~~').map(function (s) { return (s || '').trim(); }).filter(Boolean);
    }

    function makeLi(text) {
      var li = document.createElement('li');
      var idx = text.indexOf('(');
      var main = document.createElement('span');
      main.className = 'dd-mm-ben-main';
      if (idx > -1) {
        main.textContent = text.slice(0, idx).trim();
        li.appendChild(main);
        var val = document.createElement('span');
        val.className = 'dd-mm-ben-value';
        val.textContent = ' ' + text.slice(idx).trim();
        li.appendChild(val);
      } else {
        main.textContent = text;
        li.appendChild(main);
      }
      return li;
    }

    function update(section) {
      var wrap = section.querySelector('[data-dd-mm-subwrap]');
      if (!wrap) return;
      var cb = wrap.querySelector('[data-dd-mm-mode-checkbox]');
      var subscribed = cb ? cb.checked : true;
      var offers = getOffers(section);
      var tierIdx = currentTierIndex(offers);
      var tierNum = tierIdx >= 0 ? (tierIdx + 1) : 1;
      var subItems = parseList(wrap.getAttribute('data-sub-' + tierNum) || wrap.getAttribute('data-sub-1') || '');
      var oneItems = parseList(wrap.getAttribute('data-one-' + tierNum) || wrap.getAttribute('data-one-1') || '');
      var removeSet = parseList(wrap.getAttribute('data-remove-onetime') || '');

      var ul = wrap.querySelector('[data-dd-mm-benefits]');
      var oldLocked = wrap.querySelector('[data-dd-mm-locked]');
      if (oldLocked) oldLocked.remove();
      if (ul) ul.innerHTML = '';

      if (subscribed) {
        subItems.forEach(function (t) { if (ul) ul.appendChild(makeLi(t)); });
      } else {
        oneItems.forEach(function (t) { if (ul) ul.appendChild(makeLi(t)); });
        var locked = subItems.filter(function (s) { return oneItems.indexOf(s) === -1 && removeSet.indexOf(s) === -1; });
        if (locked.length && ul) {
          var box = document.createElement('div');
          box.className = 'dd-mm-locked';
          box.setAttribute('data-dd-mm-locked', '');
          var lockedUl = document.createElement('ul');
          lockedUl.className = 'dd-mm-locked-list';
          locked.forEach(function (t) { lockedUl.appendChild(makeLi(t)); });
          var overlay = document.createElement('div');
          overlay.className = 'dd-mm-locked-overlay';
          var label = document.createElement('span');
          label.textContent = wrap.getAttribute('data-locked-text') || 'Subscriber benefits locked';
          overlay.innerHTML = LOCK_SVG;
          overlay.appendChild(label);
          box.appendChild(lockedUl);
          box.appendChild(overlay);
          ul.parentNode.insertBefore(box, ul.nextSibling);
        }
      }

      var pill = wrap.querySelector('[data-dd-mm-save-pill]');
      if (pill) {
        var saveCents = 0;
        if (tierIdx >= 0) {
          var sub = Number(offers[tierIdx].dataset.bundlePrice || 0);
          var retail = Number(offers[tierIdx].dataset.retailCompare || 0);
          saveCents = retail - sub;
        }
        if (subscribed && saveCents > 0) {
          var prefix = wrap.getAttribute('data-save-prefix') || '+ Save';
          pill.textContent = prefix + ' ' + formatMoney(section, Math.round(saveCents / 100) * 100);
          pill.classList.remove('dd-mm-hidden');
        } else {
          pill.classList.add('dd-mm-hidden');
        }
      }
    }

    function initSection(section) {
      if (section.dataset.ddPurchaseInited === 'true') return;
      var wrap = section.querySelector('[data-dd-mm-subwrap]');
      if (!wrap) return;
      section.dataset.ddPurchaseInited = 'true';

      var schedule = function () {
        requestAnimationFrame(function () { update(section); });
      };

      section.addEventListener('dd-mm:mode', schedule);
      section.addEventListener('click', schedule);

      if (typeof MutationObserver !== 'undefined') {
        var obs = new MutationObserver(schedule);
        section.querySelectorAll('[data-dd-mm-row]').forEach(function (r) {
          obs.observe(r, { attributes: true, attributeFilter: ['data-qty'] });
        });
        section.querySelectorAll('[data-dd-mm-offer]').forEach(function (o) {
          obs.observe(o, { attributes: true, attributeFilter: ['class'] });
        });
      }

      update(section);
      [0, 50, 250, 800, 1500].forEach(function (ms) {
        setTimeout(function () { update(section); }, ms);
      });
    }

    function boot() {
      document.querySelectorAll('.dd-mm-section').forEach(initSection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
    document.addEventListener('shopify:section:load', function (ev) {
      var t = ev.target;
      if (t && typeof t.querySelectorAll === 'function') {
        t.querySelectorAll('.dd-mm-section').forEach(function (el) {
          delete el.dataset.ddPurchaseInited;
        });
      }
      boot();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["dd-upsell-banner"] && !Shopify.designMode) return;
  try {
    (function () {
    function computeTotal(section) {
      var total = 0;
      section.querySelectorAll('[data-dd-mm-row]').forEach(function (row) {
        total += Number(row.dataset.qty || 0);
      });
      return total;
    }

    function getThresholds(section) {
      return Array.prototype.slice.call(section.querySelectorAll('[data-dd-mm-offer]')).map(function (o, i) {
        var raw = o.dataset.qtyThreshold;
        return raw !== undefined && raw !== '' ? Number(raw) : i + 1;
      }).sort(function (a, b) { return a - b; });
    }

    function pickMessage(banner, total, thresholds) {
      var msgs = [
        banner.dataset.msgStart || '',
        banner.dataset.msgTier1 || '',
        banner.dataset.msgTier2 || ''
      ];
      var complete = banner.dataset.msgComplete || '';
      var idx = -1;
      for (var i = 0; i < thresholds.length; i++) {
        if (total < thresholds[i]) { idx = i; break; }
      }
      var msg;
      var remaining = 0;
      if (idx === -1) {
        msg = complete;
      } else {
        remaining = thresholds[idx] - total;
        msg = msgs[idx] != null ? msgs[idx] : '';
      }
      if (!msg) return null;
      var plural = remaining === 1 ? '' : 's';
      return msg
        .replace(/\{remaining\}/gi, String(remaining))
        .replace(/\{s\}/gi, plural);
    }

    function update(section) {
      var banner = section.querySelector('[data-dd-mm-encourage]');
      if (!banner) return;
      var arrow = section.querySelector('[data-dd-mm-encourage-arrow]');
      var total = computeTotal(section);
      var thresholds = getThresholds(section);
      var text = pickMessage(banner, total, thresholds);
      var textEl = banner.querySelector('[data-dd-mm-encourage-text]');
      if (text == null || text === '') {
        banner.classList.add('dd-mm-hidden');
        if (arrow) arrow.classList.add('dd-mm-hidden');
        return;
      }
      var prev = banner.getAttribute('data-current-msg');
      if (textEl) textEl.textContent = text;
      banner.classList.remove('dd-mm-hidden');
      if (arrow) arrow.classList.remove('dd-mm-hidden');
      if (textEl && prev !== null && prev !== text) {
        textEl.classList.remove('is-bumped');
        void textEl.offsetWidth;
        textEl.classList.add('is-bumped');
      }
      banner.setAttribute('data-current-msg', text);
    }

    function scrollToProducts(section) {
      var target = section.querySelector('.dd-mm-mixmatch');
      if (!target) return;
      try {
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      } catch (e) {
        target.scrollIntoView();
      }
      target.classList.remove('dd-mm-attention');
      void target.offsetWidth;
      target.classList.add('dd-mm-attention');
      setTimeout(function () { target.classList.remove('dd-mm-attention'); }, 2400);
    }

    function initSection(section) {
      if (section.dataset.ddEncourageInited === 'true') return;
      var banner = section.querySelector('[data-dd-mm-encourage]');
      if (!banner) return;
      section.dataset.ddEncourageInited = 'true';
      var arrow = section.querySelector('[data-dd-mm-encourage-arrow]');

      var schedule = function () {
        requestAnimationFrame(function () { update(section); });
      };

      if (typeof MutationObserver !== 'undefined') {
        var observer = new MutationObserver(schedule);
        section.querySelectorAll('[data-dd-mm-row]').forEach(function (row) {
          observer.observe(row, { attributes: true, attributeFilter: ['data-qty'] });
        });
      }
      section.addEventListener('click', schedule);

      var go = function (e) { if (e) e.preventDefault(); scrollToProducts(section); };
      var keyGo = function (e) {
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') { e.preventDefault(); scrollToProducts(section); }
      };
      banner.addEventListener('click', go);
      banner.addEventListener('keydown', keyGo);
      if (arrow) {
        arrow.addEventListener('click', go);
        arrow.addEventListener('keydown', keyGo);
      }

      update(section);
      [0, 50, 250, 800, 1500].forEach(function (ms) {
        setTimeout(function () { update(section); }, ms);
      });
    }

    function boot() {
      document.querySelectorAll('.dd-mm-section').forEach(initSection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
    document.addEventListener('shopify:section:load', function (ev) {
      var t = ev.target;
      if (t && typeof t.querySelectorAll === 'function') {
        t.querySelectorAll('.dd-mm-section').forEach(function (el) {
          delete el.dataset.ddEncourageInited;
        });
      }
      boot();
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
